export interface TimelineVertex {
  x: number;
  y: number;
  r: number;
  g: number;
  b: number;
  a: number;
}

export function pushLine(
  verts: TimelineVertex[],
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  r: number,
  g: number,
  b: number,
  a: number,
  thickness = 1,
): void {
  if (Math.abs(x1 - x0) >= Math.abs(y1 - y0)) {
    pushQuad(verts, x0, y0 - thickness, x1, y0 + thickness, r, g, b, a);
    return;
  }
  pushQuad(verts, x0 - thickness, y0, x0 + thickness, y1, r, g, b, a);
}

export function pushQuad(
  verts: TimelineVertex[],
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  r: number,
  g: number,
  b: number,
  a: number,
): void {
  verts.push(
    { x: x0, y: y0, r, g, b, a },
    { x: x1, y: y0, r, g, b, a },
    { x: x0, y: y1, r, g, b, a },
    { x: x1, y: y0, r, g, b, a },
    { x: x1, y: y1, r, g, b, a },
    { x: x0, y: y1, r, g, b, a },
  );
}

export function pushCircle(
  verts: TimelineVertex[],
  cx: number,
  cy: number,
  radius: number,
  r: number,
  g: number,
  b: number,
  a: number,
): void {
  const segments = 14;
  const center = { x: cx, y: cy, r, g, b, a };
  for (let i = 0; i < segments; i++) {
    const t0 = (i / segments) * Math.PI * 2;
    const t1 = ((i + 1) / segments) * Math.PI * 2;
    verts.push(
      center,
      {
        x: cx + Math.cos(t0) * radius,
        y: cy + Math.sin(t0) * radius,
        r,
        g,
        b,
        a,
      },
      {
        x: cx + Math.cos(t1) * radius,
        y: cy + Math.sin(t1) * radius,
        r,
        g,
        b,
        a,
      },
    );
  }
}
